<ng-container *ngIf="groupedTransfers || loading()">
  <ng-container *ngTemplateOutlet="cardTransfer; context: { $implicit: transfers$ | async }"></ng-container>

  <ng-template #cardTransfer let-transfers>
    <lx-card-container
      type="transfer"
      [loading]="loading()"
      i18n-title
      title="Your transfer"
      [actionMode]="!transfers?.length ? 'add' : 'edit'"
      [disabled]="!transfers?.length"
      [price]="price"
      [endPrice]="endPrice"
      [currency]="currency?.()"
      [discount]="discount"
      (buttonClick)="openDialog()"
      [gaEventName]="dataLayerEventName$ | async"
      data-qa="transfers_card"
    >
      <div i18n *ngIf="(activeFlow$ | async) === Flows.Adult; else juniorDisclaimer">Enjoy a hassle-free journey to or from your school or accommodation.</div>
      <div class="card-container-highlighted">
        <div *ngIf="arrival">{{ arrival }}</div>
        <div *ngIf="departure">{{ departure }}</div>
      </div>
    </lx-card-container>
  </ng-template>

  <lx-side-panel
    i18n-title
    title="Transfer (arrival & departure)"
    size="large"
    *ngIf="dialogVisible"
    [activeFlow]="activeFlow$ | async"
    [visible]="dialogVisible"
    (hiddenPanel)="hideDialog()"
    footerButtonText="Apply"
    i18n-footerButtonText
    (footerButtonClicked)="saveTransferRows()"
  >
    <lx-transfers-selector
      [groupedTransfers]="groupedTransfers"
      [preselectedTransferRows$]="transferRows$"
      [activeFlow$]="activeFlow$"
      (transferRowsSelected)="setSelectedTransferRows($event)"
    ></lx-transfers-selector>
  </lx-side-panel>
</ng-container>

<ng-template #juniorDisclaimer>
  <div i18n>Enjoy a hassle-free journey to or from your camp.</div>
</ng-template>
